import { useState } from "react"
import { HelpCenterButton } from "./components/HelpCenterButton"
import { MembershipSection } from "./components/sections/MembershipSection"
import { HelpSections } from "./consts/HelpSections"
import { HelpCenterSectionModel } from "./models/HelpCenterSectionModel"
import { useHistory } from "react-router-dom"

export const HelpCenterList = () => {
    const [sectionSelected, setSectionSelected] = useState<HelpCenterSectionModel | null>(HelpSections[0]);
    const history = useHistory()

    return (<>
        <div className="help-center-sections w-100 tap-flex-center justify-content-start mb-4">
            <div className="nb-link-underline-500 w-auto cursor-pointer" onClick={()=> history.goBack()}>
                Back
            </div>
        </div>
        <div className="help-center-container">

            <div className="help-center-header">
                <span>The Nobilis Guide</span>
                <h2>
                    A curated resource for members to understand their privileges, responsibilities, and opportunities within the Nobilis community.
                </h2>
                <div className='nbx-lines' aria-hidden='true'>
                    <span className='nbx-lines__line' />
                    <span>
                        <img src='/media/svg/nobilis/mark.svg' alt='divider' className='payment-card__icon' />
                    </span>
                    <span className='nbx-lines__line' />
                </div>
            </div>

            <div className="help-center-sections">
                <div className="help-center-sections-list">
                    {HelpSections.map((s, i) => (
                        <HelpCenterButton title={s.title} key={i} active={sectionSelected === s} onClick={() => setSectionSelected(s)}/>
                    ))}    
                </div>
                { sectionSelected && sectionSelected?.section }
            </div>
            
        </div> 
    </>)
}